import {SearchNoGamesFoundDefaultBox} from "./search-no-games-found.default.box";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {SearchNoGamesFoundCasino777Box} from "./search-no-games-found.casino777.box";

export const SearchNoGamesFoundBox = styledByTheme(SearchNoGamesFoundDefaultBox)
    .forCasino777(SearchNoGamesFoundCasino777Box)
    .apply();